import React, {useEffect,useState } from "react";
import './games.css'


const Games = () => {
    
    
    const [gamesData, setGameData] = useState([]);

    useEffect(() => {
        fetch("/games")
        .then(response => response.json()).then(data => {setGameData(data);
        }).catch((error)=>{
            console.error('Error fetching data:', error)
        })
        ;
    },[]);

    return(
        <div>
            <h1>Games & Descriptions</h1>
            <table>
                <thead>
                    <tr>
                        <th>Game Title</th>
                        <th>Description</th>
                    </tr>
                </thead>
                <tbody>
                    {gamesData?.map((game) =>
                    (
                    <tr key={game.id}>
                        <td>{game.title}</td>
                        <td>{game.description}</td>
                    </tr>
                    )
                    )}   
                </tbody>
            </table>
                       
        </div>
     );
};
export default Games;
